import React, { FC, Suspense } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  // Redirect
} from 'react-router-dom'

import { Alert } from 'antd'
import { LoadingFallback } from './LoadingFallback'
import { Validators } from '../pages/validators/Validators'
import { AppShell } from '../components/AppShell'
import { Bridge } from '../pages/bridge/Bridge'
import { Connect } from '../pages/create/Connect'

export const AppRoutes: FC = () => (
  <Suspense fallback={<LoadingFallback />}>
    <Router>
      <AppShell>
        <>
          <Alert
            message="WalletConnect QR scan is currently disabled. Please use Metamask or other wallets directly."
            type="warning"
            showIcon
          />
          <Switch>
            <Route exact path="/">
              <Connect />
            </Route>
            <Route exact path="/validators">
              <Validators />
            </Route>
            <Route exact path="/gno-bridge">
              <Bridge />
            </Route>
          </Switch>
        </>
      </AppShell>
    </Router>
  </Suspense>
)
